import Popover from 'trunks/vue/admin/components/libs/popover.js';
import { newAlertify } from 'trunks/vue/admin/components/alert.js';

export default Vue.extend({
  components: {
    Popover,
  },

  props: {
    row: {
      type: Object,
    },
    organization: {
      type: Object,
    },
  },

  template: `
    <Popover position='bottom center' v-if='row.id' :customClass='"confirm table-operation-confirm-popover delete-confirm-popover"' ref="deleteUserconfirmPopoverRef">
      <template slot='trigger'>
        <span class="operation-cell btn-text error-text" @click.stop="togglePopover">移除</span>
      </template>
      <template slot='content'>
        <div class="popover-confirm-content">
          <div class="popover-confirm-title">确认移除成员</div>
          <div class="popover-confirm-footer">
            <span class="btn btn-small btn-default outlined" @click.stop="close">取消</span>
            <span class="btn btn-small btn-danger" @click.stop="deleteMember">移除</span>
          </div>
        </div>
      </template>
    </Popover>
  `,

  methods: {
    deleteMember() {
      Skylark.Libs.Ajax.put(Skylark.Helpers.UrlHelper.adminUrlFor(`organizations/${this.organization.id}/members/remove`), {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          member_ids: [this.row.id],
        },
        success: () => {
          newAlertify('移除成功', {
            type: 'success',
          });
          this.$emit('deleteMemberSuccessed');
        },
        error() {
          newAlertify('移除失败', {
            type: 'error',
          });
        },
        complete: () => {
          this.close();
        },
      });
    },

    close() {
      this.$refs.deleteUserconfirmPopoverRef.close();
    },

    togglePopover() {
      this.$refs.deleteUserconfirmPopoverRef.togglePopover();
    },
  },
});
